import React from "react"
import classnames from "classnames"
import { Calendar } from "@fullcalendar/core"
import interaction from "@fullcalendar/interaction"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import ReactBSAlert from "react-bootstrap-sweetalert"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import { compose } from "redux"
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  // Form,
  Input,
  Modal,
  Container,
  Row,
  Col,
} from "reactstrap"
import NotificationAlert from "react-notification-alert"
import AddToCalendar from "react-add-to-calendar"
import "react-add-to-calendar/dist/react-add-to-calendar.css"
import moment from "moment"

import * as fire from "firebase"

import {
  cancelOrConfirmOrder,
  updateMerchantOrderSlots,
} from "actions/organization/usersActions"

let calendar

class MerchantDashboard extends React.Component {
  state = {
    alert: null,
    event: null,
    eventId: null,
    events: [],
    merchantCancelledOrders: [],
    merchantConfirmedOrders: [],
  }

  componentDidMount() {
    // console.log('Component Did Mount - Merchant Dashboard');
    // console.log(this.props.orders);
    if (this.props.orders && this.props.orders.length > 0) {
      const events = this._getEventsFromOrders(this.props.orders)
      this.setState({ events })
      this.createCalendar(events)
    }
    // console.log('----- ----- -----')
  }

  componentDidUpdate(prevProps) {
    // console.log('Component Did Update - Merchant Dashboard');
    // console.log(prevProps.orders);
    // console.log(this.props.orders);
    const currProps = this.props
    if (
      prevProps &&
      !prevProps.orders &&
      currProps &&
      currProps.orders &&
      currProps.orders.length > 0 &&
      !calendar
    ) {
      const events = this._getEventsFromOrders(currProps.orders)
      this.setState({ events })
      this.createCalendar(events)
    }
    // console.log('----- ----- -----')
  }

  componentWillUnmount() {
    // console.log('Component Will Unmount - Merchant Dashboard');
    // console.log('----- ----- -----')
  }

  _getEventsFromOrders(orders) {
    let events = []
    if (orders && orders.length > 0) {
      events = [...orders].map((item) => {
        const startTime = this._get24HourTime(item.orderTime)
        const startTimeArr = startTime.split(":")
        const startStrHours = parseInt(startTimeArr[0])
        const startStrMinutes = parseInt(startTimeArr[1])
        const orderDate =
          typeof item.orderDate === "string"
            ? moment(item.orderDate, "DD-MM-YYYY").toDate()
            : item.orderDate.toDate()
        let startStr = new Date(orderDate).setHours(
          startStrHours,
          startStrMinutes
        )
        startStr = new Date(startStr)

        const orderDurationSegments = Math.ceil(
          parseInt(item.orderDuration) / 30
        )
        const endStrHours =
          startStrHours + Math.floor(orderDurationSegments / 2)
        const endStrMinutes = orderDurationSegments % 2 === 0 ? 0 : 30
        let endStr = new Date(orderDate).setHours(
          endStrHours,
          startStrMinutes + endStrMinutes
        )
        endStr = new Date(endStr)

        // console.log(orderDurationSegments);
        // console.log(endStrHours);
        // console.log(endStrMinutes);
        // console.log(item.orderTime);
        // console.log(item.orderDuration);
        // console.log(startStr);
        // console.log(endStr);
        // console.log('-----');

        let className = "bg-chift"
        if (item.merchantCancelled) {
          className = "bg-danger"
        } else if (item.merchantConfirmed) {
          className = "bg-success"
        }

        return {
          ...item,
          title: (item.firstName || "") + " " + (item.lastName || ""),
          start: startStr,
          end: endStr,
          className,
        }
      })
    }
    return events
  }

  createCalendar = (events) => {
    calendar = new Calendar(this.refs.calendar, {
      plugins: [interaction, dayGridPlugin, timeGridPlugin],
      defaultView: "timeGridWeek",
      allDaySlot: false,
      minTime: "06:00",
      maxTime: "22:00",
      selectable: true,
      selectHelper: true,
      editable: true,
      events: events || this.state.events,
      // =================================
      // ===== Calendar Event Select =====
      // =================================
      select: (info) => {
        this.changeView("timeGridDay", info.startStr)
        // this.setState({
        //   modalAdd: true,
        //   startDate: info.startStr,
        //   endDate: info.endStr,
        //   radios: "bg-info"
        // });
      },
      // ==============================
      // ==== Calendar Event Action ===
      // ==============================
      eventClick: ({ event }) => {
        this.setState({
          modalChange: true,
          eventId: event.id,
          eventTitle: event.title,
          event,
        })
      },
    })
    calendar.render()
    this.setState({
      currentDate: calendar.view.title,
    })
  }

  handleDateSelect = (info) => {
    this.setState({
      modalAdd: true,
      startDate: info.startStr,
      endDate: info.endStr,
      radios: "bg-info",
    })
  }

  handleEvenClick = ({ event }) => {
    this.setState({
      modalChange: true,
      eventId: event.id,
      eventTitle: event.title,
      eventDescription: event.extendedProps.description,
      radios: "bg-info",
      event: event,
    })
  }

  changeView = (newView, dateOrRange = "") => {
    // console.log(newView);
    // console.log(calendar.view.title);
    if (calendar) {
      calendar.changeView(newView, dateOrRange)
      this.setState({
        currentDate: calendar.view.title,
      })
    }
  }

  addNewEvent = () => {
    var newEvents = this.state.events
    newEvents.push({
      title: this.state.eventTitle,
      start: this.state.startDate,
      end: this.state.endDate,
      className: this.state.radios,
      id: this.state.events[this.state.events.length - 1] + 1,
    })
    calendar.addEvent({
      title: this.state.eventTitle,
      start: this.state.startDate,
      end: this.state.endDate,
      className: this.state.radios,
      id: this.state.events[this.state.events.length - 1] + 1,
    })
    this.setState({
      modalAdd: false,
      events: newEvents,
      startDate: undefined,
      endDate: undefined,
      radios: "bg-info",
      eventTitle: undefined,
    })
  }

  changeEvent = () => {
    var newEvents = this.state.events.map((prop, key) => {
      if (prop.id + "" === this.state.eventId + "") {
        this.state.event.remove()
        calendar.addEvent({
          ...prop,
          title: this.state.eventTitle,
          className: this.state.radios,
          description: this.state.eventDescription,
        })
        return {
          ...prop,
          title: this.state.eventTitle,
          className: this.state.radios,
          description: this.state.eventDescription,
        }
      } else {
        return prop
      }
    })
    this.setState({
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined,
    })
  }

  _changeEventClassName = (customClass) => {
    if (customClass) {
      var newEvents = this.state.events.map((event) => {
        if (event.id + "" === this.state.event.id + "") {
          this.state.event.remove() // Removing An Event From The Calendar
          event.className = customClass
          calendar.addEvent({
            ...event,
          })
          return {
            ...event,
          }
        }
        return event
      })
      this.setState({
        events: newEvents,
      })
    }
  }

  deleteEventSweetAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() =>
            this.setState({
              alert: false,
              radios: "bg-info",
              eventTitle: undefined,
              eventDescription: undefined,
              eventId: undefined,
            })
          }
          onCancel={() => this.deleteEvent()}
          confirmBtnCssClass="btn-secondary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Cancel"
          cancelBtnText="Yes, delete it"
          showCancel
          btnSize=""
        >
          You won't be able to revert this!
        </ReactBSAlert>
      ),
    })
  }

  deleteEvent = () => {
    var newEvents = this.state.events.filter(
      (prop) => prop.id + "" !== this.state.eventId
    )
    this.state.event.remove()
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Success"
          onConfirm={() => this.setState({ alert: null })}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          A few words about this sweet alert ...
        </ReactBSAlert>
      ),
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined,
    })
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  _isEventCancelled(event) {
    if (event && event.extendedProps) {
      return (
        event.extendedProps.merchantCancelled ||
        this.state.merchantCancelledOrders.indexOf(
          event.extendedProps.orderId
        ) > -1
      )
    }
    return false
  }

  _isEventConfirmed(event) {
    if (event && event.extendedProps) {
      return (
        event.extendedProps.merchantConfirmed ||
        this.state.merchantConfirmedOrders.indexOf(
          event.extendedProps.orderId
        ) > -1
      )
    }
    return false
  }

  _getUpdateDataForMerchantOrderSlots(event) {
    const data = {}
    if (event) {
      const { extendedProps } = event
      let { orderTime, orderDuration, orderId, orderDate, orderDateOffset } =
        extendedProps
      const bookedOrderSlots = Math.ceil(orderDuration / 30)
      orderTime = this._get24HourTime(orderTime)
      const startNum = this._getHoursFromTimeString(orderTime)
      const endNum = startNum + bookedOrderSlots / 2
      let slotId = this._getLocalISODateString(
        orderDate.toDate(),
        orderDateOffset
      )
      slotId = slotId.split("T")[0]
      // console.log(startNum, endNum);
      for (let i = startNum; i < endNum; i += 0.5) {
        const slotStart = i
        const slotEnd = i + 0.5
        const startHour = this._getTimeStringFromHours(slotStart)
        const endHour = this._getTimeStringFromHours(slotEnd)
        // console.log('i', i, slotStart, slotEnd, startHour, endHour);
        data[`${slotId}.${startHour}-${endHour}.isBooked`] = false
        data[`${slotId}.${startHour}-${endHour}.orderId`] =
          fire.firestore.FieldValue.arrayRemove(orderId)
      }
    }
    console.log(data)
    return data
  }

  _getLocalISODateString = (date = "", offset = 0) => {
    if (date && typeof offset === "number") {
      return new Date(date.getTime() + -1 * offset * 60 * 1000).toISOString()
    }
    console.log("Issue with date or offset")
    return ""
  }

  _getHoursFromTimeString(time) {
    let num = 0
    if (time) {
      const timeArr = time.split(":")
      let hour = parseInt(timeArr[0])
      let min = parseInt(timeArr[1])
      num = hour
      if (min) {
        num += 0.5
      }
      return num
    }
    return num
  }

  _getTimeStringFromHours(num) {
    let hour = ""
    if (num) {
      const format = (num) => ((num + "").length === 1 ? "0" + num : num)
      if (Number.isInteger(num)) {
        hour = format(num)
        hour += ":00"
      } else {
        hour = format((num + "").split(".")[0])
        hour += ":30"
      }
      return hour
    }
    return hour
  }

  _get24HourTime(time) {
    let newTime = ""
    if (time) {
      const startFtd = typeof time === "string" ? time : time?.startFtd
      const timeArr = startFtd?.split(":") || []
      const hour = parseInt(timeArr[0]),
        min = parseInt(timeArr[1])
      const isAM = startFtd.includes("AM")
      const isPM = startFtd.includes("PM")
      const format = (num) => ((num + "").length === 1 ? "0" + num : num)
      if (hour === 12 && isAM) {
        newTime = `00:${format(min)}` // ToDo: Format Min To Two Digits, If It Is One Digit
      } else if (1 <= hour && hour <= 11 && isAM) {
        newTime = `${format(hour)}:${format(min)}`
      } else if (hour === 12 && isPM) {
        newTime = `${hour}:${format(min)}`
      } else if (1 <= hour && hour <= 11 && isPM) {
        newTime = `${hour + 12}:${format(min)}`
      }
    }
    return newTime
  }

  _getAddToCalendarEvent(event) {
    let reactAddEvent = {
      title: "FAVER Event",
      location: "",
      description: "",
    }
    if (event) {
      const {
        extendedProps: {
          city,
          orderId,
          firstName,
          lastName,
          phone,
          addressLine1,
          addressLine2,
          zipCode,
          totalCost,
          orderDate,
          orderTime,
          orderDuration,
          vehicleType,
          package: pkg,
          addon,
        },
      } = event
      reactAddEvent = {
        ...reactAddEvent,
        location: city,
        description: `Name: ${firstName} ${lastName}\nPhone: ${phone}\nAddress: ${addressLine1}, ${
          addressLine2 ? addressLine2 + ", " : ""
        }${city}, ${zipCode}\nTotal Amount: $${totalCost}\nOrder Date: ${orderDate
          .toDate()
          .toDateString()}\nOrder Time: ${orderTime}\nOrder Duration: ${orderDuration} Min\nVehicle Type: ${
          vehicleType.title
        }\nPackage: ${pkg.title}\nAddon: ${
          addon.map((v) => v.title).join(", ") || "NA"
        }\nOrderId: ${orderId}`,
        startTime: new Date(
          orderDate.toDate().getTime() +
            this._getHoursFromTimeString(orderTime) * 60 * 60 * 1000
        ),
        endTime: new Date(
          orderDate.toDate().getTime() +
            this._getHoursFromTimeString(orderTime) * 60 * 60 * 1000 +
            +orderDuration * 60 * 1000
        ),
      }
    }
    return reactAddEvent
  }

  render() {
    const { event } = this.state
    let orderCreationTime // ToDo: Use a Method
    if (event) {
      const hours = event.extendedProps.time.toDate().getHours()
      let minutes = event.extendedProps.time.toDate().getMinutes()
      minutes = minutes.toString()
      if (minutes.length === 1) {
        minutes = "0" + minutes
      }
      orderCreationTime = hours + ":" + minutes
    }
    return (
      <>
        {this.state.alert}
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div className="header pb-6 content__title content__title--calendar">
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="6">
                  <h6 className="fullcalendar-title h2 d-inline-block mb-0 mr-1">
                    {this.state.currentDate}
                  </h6>
                </Col>
                <Col className="mt-3 mt-md-0 text-md-right" lg="6">
                  <Button
                    className="fullcalendar-btn-prev btn-neutral"
                    color="default"
                    onClick={() => {
                      calendar.prev()
                      this.setState({
                        currentDate: calendar.view.title,
                      })
                    }}
                    size="sm"
                  >
                    <i className="fas fa-angle-left" />
                  </Button>
                  <Button
                    className="fullcalendar-btn-next btn-neutral"
                    color="default"
                    onClick={() => {
                      calendar.next()
                      this.setState({
                        currentDate: calendar.view.title,
                      })
                    }}
                    size="sm"
                  >
                    <i className="fas fa-angle-right" />
                  </Button>
                  <Button
                    className="btn-neutral"
                    color="default"
                    data-calendar-view="month"
                    onClick={() => this.changeView("dayGridMonth")}
                    size="sm"
                  >
                    Month
                  </Button>
                  <Button
                    className="btn-neutral"
                    color="default"
                    data-calendar-view="basicWeek"
                    onClick={() => this.changeView("timeGridWeek")}
                    size="sm"
                  >
                    Week
                  </Button>
                  <Button
                    className="btn-neutral"
                    color="default"
                    data-calendar-view="basicDay"
                    onClick={() => this.changeView("timeGridDay")}
                    size="sm"
                  >
                    Day
                  </Button>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card className="card-calendar">
                <CardHeader>
                  <h5 className="h3 mb-0">Calendar</h5>
                </CardHeader>
                <CardBody className="p-0">
                  <div
                    className="calendar"
                    data-toggle="calendar"
                    id="calendar"
                    ref="calendar"
                  />
                </CardBody>
              </Card>
              {/*
                ==================================
                === Modal For Adding New Event ===
                ==================================
              */}
              <Modal
                isOpen={this.state.modalAdd}
                toggle={() => this.setState({ modalAdd: false })}
                className="modal-dialog-centered modal-secondary"
              >
                <div className="modal-body">
                  <form className="new-event--form">
                    <FormGroup>
                      <label className="form-control-label">Event title</label>
                      <Input
                        className="form-control-alternative new-event--title"
                        placeholder="Event Title"
                        type="text"
                        onChange={(e) =>
                          this.setState({ eventTitle: e.target.value })
                        }
                      />
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <label className="form-control-label d-block mb-3">
                        Status color
                      </label>
                      <ButtonGroup
                        className="btn-group-toggle btn-group-colors event-tag"
                        data-toggle="buttons"
                      >
                        <Button
                          className={classnames("bg-info", {
                            active: this.state.radios === "bg-info",
                          })}
                          color=""
                          type="button"
                          onClick={() => this.setState({ radios: "bg-info" })}
                        />
                        <Button
                          className={classnames("bg-warning", {
                            active: this.state.radios === "bg-warning",
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-warning" })
                          }
                        />
                        <Button
                          className={classnames("bg-danger", {
                            active: this.state.radios === "bg-danger",
                          })}
                          color=""
                          type="button"
                          onClick={() => this.setState({ radios: "bg-danger" })}
                        />
                        <Button
                          className={classnames("bg-success", {
                            active: this.state.radios === "bg-success",
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-success" })
                          }
                        />
                        <Button
                          className={classnames("bg-default", {
                            active: this.state.radios === "bg-default",
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-default" })
                          }
                        />
                        <Button
                          className={classnames("bg-primary", {
                            active: this.state.radios === "bg-primary",
                          })}
                          color=""
                          type="button"
                          onClick={() => {
                            this.setState({ radios: "bg-primary" })
                          }}
                        />
                      </ButtonGroup>
                    </FormGroup>
                  </form>
                </div>
                <div className="modal-footer">
                  <Button
                    className="new-event--add"
                    color="primary"
                    type="button"
                    onClick={this.addNewEvent}
                  >
                    Add event
                  </Button>
                  <Button
                    className="ml-auto"
                    color="link"
                    type="button"
                    onClick={() => this.setState({ modalAdd: false })}
                  >
                    Close
                  </Button>
                </div>
              </Modal>
              {/*
                ==========================================
                === Modal For Viewing/Editing An Event ===
                ==========================================
              */}
              <Modal
                isOpen={this.state.modalChange}
                toggle={() => this.setState({ modalChange: false })}
                className="modal-dialog-centered modal-secondary"
              >
                <div className="modal-header">
                  <h6 className="modal-title" id="modal-title-default">
                    Order Summary
                  </h6>
                  <Col className="text-right" xs="6">
                    <AddToCalendar
                      buttonLabel="Add to Calendar"
                      event={this._getAddToCalendarEvent(event)}
                      listItems={[
                        { google: "Google" },
                        { apple: "Apple Calendar" },
                        { outlook: "Outlook" },
                        { outlookcom: "Outlook.com" },
                      ]}
                    />
                  </Col>
                </div>
                <div className="modal-body">
                  {event ? (
                    <React.Fragment>
                      <b className="form-control-label">Name:</b>{" "}
                      {`${event.extendedProps.firstName} ${event.extendedProps.lastName}`}
                      <br />
                      <b className="form-control-label">Phone:</b>{" "}
                      {event.extendedProps.phone}
                      <br />
                      <b className="form-control-label">Address:</b>{" "}
                      {event.extendedProps.addressLine1 +
                        ", " +
                        (event.extendedProps.addressLine2
                          ? event.extendedProps.addressLine2 + ", "
                          : "") +
                        event.extendedProps.city +
                        ", " +
                        event.extendedProps.zipCode}
                      <br />
                      <b className="form-control-label">Total Amount:</b>{" "}
                      {`$${event.extendedProps.totalCost}`}
                      <br />
                      <b className="form-control-label">Order Date:</b>{" "}
                      {event.extendedProps.orderDate.toDate().toDateString()}
                      <br />
                      <b className="form-control-label">Order Time:</b>{" "}
                      {event.extendedProps.orderTime}
                      <br />
                      <b className="form-control-label">Order Duration:</b>{" "}
                      {event.extendedProps.orderDuration
                        ? event.extendedProps.orderDuration + " Min"
                        : "-"}
                      <br />
                      <b className="form-control-label">Vehicle Type:</b>{" "}
                      {event.extendedProps.vehicleType.title}
                      <br />
                      <b className="form-control-label">Package:</b>{" "}
                      {event.extendedProps.package.title}
                      <br />
                      <b className="form-control-label">Addon:</b>{" "}
                      {event.extendedProps.addon
                        .map((v) => v.title)
                        .join(", ") || "NA"}
                      <br />
                      <b className="form-control-label">Order Id:</b>{" "}
                      {event.extendedProps.orderId || ""}
                      <br />
                      <br />
                    </React.Fragment>
                  ) : null}
                  {/*
                    =======================================================
                    ===== Changing Color Of Event In Calendar - START =====
                    =======================================================
                  */}
                  {/* <Form className="edit-event--form">
                    <FormGroup className='mb-0'>
                      <label className="form-control-label d-block mb-3">
                        Status Color
                      </label>
                      <ButtonGroup
                        className="btn-group-toggle btn-group-colors event-tag mb-0"
                        data-toggle="buttons"
                      >
                        <Button
                          className={classnames("bg-info", {
                            active: this.state.radios === "bg-info"
                          })}
                          color=""
                          type="button"
                          onClick={() => this.setState({ radios: "bg-info" })}
                        />
                        <Button
                          className={classnames("bg-warning", {
                            active: this.state.radios === "bg-warning"
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-warning" })
                          }
                        />
                        <Button
                          className={classnames("bg-danger", {
                            active: this.state.radios === "bg-danger"
                          })}
                          color=""
                          type="button"
                          onClick={() => this.setState({ radios: "bg-danger" })}
                        />
                        <Button
                          className={classnames("bg-success", {
                            active: this.state.radios === "bg-success"
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-success" })
                          }
                        />
                        <Button
                          className={classnames("bg-default", {
                            active: this.state.radios === "bg-default"
                          })}
                          color=""
                          type="button"
                          onClick={() =>
                            this.setState({ radios: "bg-default" })
                          }
                        />
                        <Button
                          className={classnames("bg-primary", {
                            active: this.state.radios === "bg-primary"
                          })}
                          color=""
                          type="button"
                          onClick={() => {
                            this.setState({ radios: "bg-primary" });
                          }}
                        />
                      </ButtonGroup>
                    </FormGroup>
                    <input className="edit-event--id" type="hidden" />
                  </Form> */}
                  {/*
                    =======================================================
                    ===== Changing Color Of Event In Calendar - END =======
                    =======================================================
                  */}
                </div>
                <div className="modal-footer">
                  {/*
                    ==================================================================
                    ===== Changing Color Of Event In Calendar - BUTTON - START =======
                    ==================================================================
                  */}
                  {/* <Button color="primary" onClick={this.changeEvent}>
                    Update
                  </Button> */}
                  {/*
                    ================================================================
                    ===== Changing Color Of Event In Calendar - BUTTON - END =======
                    ================================================================
                  */}
                  <div className="d-flex align-items-center justify-content-evenly w-100">
                    {event ? (
                      <React.Fragment>
                        <Button
                          disabled={
                            this._isEventCancelled(event) ||
                            this._isEventConfirmed(event)
                          }
                          color="primary"
                          onClick={() => {
                            this.props
                              .cancelOrConfirmOrder({
                                status: "confirm",
                                orderId: event.extendedProps.orderId,
                              })
                              .then((isOrderCancelledOrConfirmed) => {
                                if (isOrderCancelledOrConfirmed) {
                                  this._changeEventClassName("bg-success")
                                  this.notify(
                                    "success",
                                    "Order Confirmed!",
                                    "Confirmed"
                                  )
                                  this.setState({
                                    merchantConfirmedOrders: [
                                      ...this.state.merchantConfirmedOrders,
                                      event.extendedProps.orderId,
                                    ],
                                  })
                                }
                              })
                          }}
                        >
                          {this._isEventConfirmed(event)
                            ? "Confirmed Order"
                            : "Confirm Order"}
                        </Button>
                        <Button
                          disabled={this._isEventCancelled(event)}
                          color="primary"
                          onClick={() => {
                            this.props
                              .cancelOrConfirmOrder({
                                status: "cancel",
                                orderId: event.extendedProps.orderId,
                              })
                              .then((isOrderCancelledOrConfirmed) => {
                                if (isOrderCancelledOrConfirmed) {
                                  const updateData =
                                    this._getUpdateDataForMerchantOrderSlots(
                                      event
                                    )
                                  this.props.updateMerchantOrderSlots({
                                    updateData,
                                    docId: event.extendedProps.merchantId,
                                  })
                                  this._changeEventClassName("bg-danger")
                                  this.notify(
                                    "danger",
                                    "Order Cancelled!",
                                    "Cancelled"
                                  )
                                  this.setState({
                                    merchantCancelledOrders: [
                                      ...this.state.merchantCancelledOrders,
                                      event.extendedProps.orderId,
                                    ],
                                  })
                                }
                              })
                          }}
                        >
                          {this._isEventCancelled(event)
                            ? "Cancelled Order"
                            : "Cancel Order"}
                        </Button>
                      </React.Fragment>
                    ) : null}
                    <Button
                      className="ml-auto"
                      color="link"
                      onClick={() => this.setState({ modalChange: false })}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Modal>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

// export default MerchantDashboard;

const mapStateToProps = (state) => {
  // console.log(state)
  return {
    orders: state.firestore.ordered.orders,
    email: state.firebase.auth.email,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cancelOrConfirmOrder: (data) => dispatch(cancelOrConfirmOrder(data)),
    updateMerchantOrderSlots: (data) =>
      dispatch(updateMerchantOrderSlots(data)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: `orders`,
      where: ["merchantEmail", "==", props.email],
      storeAs: "orders",
    },
  ])
)(MerchantDashboard)
